import { useEffect, useRef } from "react";
import arrowDownGolden from "../../../../assets/images/svg/arrowDownGolden.svg";
import FilledButton from "../../../SelectButton/FilledButton";
import EmptyButton from "../../../SelectButton/EmptyButton";
import { useCallback } from "react";

function Dropdown({
  selected = { value: "" },
  position,
  items = [],
  handleChange,
  setOpen,
  open,
  dropdownBtnStyles = {},
  valuePropertyName = "value",
  labelPropertyName = "value",
  menuClassName = "",
}) {
  const ref = useRef(null);

  const onClickOutside = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        onClickOutside && onClickOutside();
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [onClickOutside]);

  return (
    <div ref={ref} style={{ position: "relative" }}>
      <div className="info-box-wrapper">
        <button
          className={`equity-dropdown dropdown_btn`}
          onClick={() => {
            setOpen(!open);
          }}
          style={dropdownBtnStyles}
        >
          <p className="selected_text equity_dropdown_selected_text">
            {typeof selected === "string"
              ? selected
              : selected?.value?.length > 25
              ? `${selected?.value?.slice(0, 25)}...`
              : selected[labelPropertyName]}
          </p>
          <div className={`golden_down_arrow`}>
            <div className="profile_arrow_section">
              <img src={arrowDownGolden} alt="" />
            </div>
          </div>
        </button>
        {open && (
          <ul className={`dropdown-content ${menuClassName}`} style={position}>
            {typeof items === "function"
              ? items()
              : items?.map((accountData, index) => (
                  <li
                    onClick={() => {
                      handleChange(accountData);
                      setOpen(false);
                    }}
                    style={{
                      borderBottom:
                        index !== items.length - 1 &&
                        "1px solid rgba(214, 214, 214, 0.29)",
                    }}
                  >
                    <div>
                      {accountData[valuePropertyName] ===
                      selected[valuePropertyName] ? (
                        <FilledButton />
                      ) : (
                        <EmptyButton />
                      )}
                    </div>
                    <label for={accountData.account_Code}>
                      {accountData[labelPropertyName]}
                    </label>
                  </li>
                ))}
          </ul>
        )}
      </div>
    </div>
  );
}
export default Dropdown;
